import type { SortDescriptor } from '@skupreme/shared/ui';
import type { ISortObject } from '../legacy-bridge';

export type CatalogSortKey = 'p_sku' | 'total_inventory' | 'available';

/* Stock is read most-first; everything else starts A→Z. */
const FIRST_DIRECTION: Record<CatalogSortKey, 'asc' | 'desc'> = {
  p_sku: 'asc',
  total_inventory: 'desc',
  available: 'desc',
};

export function toSortDescriptor(
  sort: ISortObject,
): SortDescriptor | undefined {
  const [column, direction] = Object.entries(sort)[0] ?? [];

  if (!column) {
    return undefined;
  }

  return {
    column,
    direction: direction === 'desc' ? 'descending' : 'ascending',
  };
}

/*
 * React Aria opens every newly picked column ascending; a column with its own
 * first direction starts there instead, then toggles as usual.
 */
export function fromSortDescriptor(
  descriptor: SortDescriptor,
  current: ISortObject,
): ISortObject {
  const column = String(descriptor.column) as CatalogSortKey;

  if (!(column in current)) {
    return { [column]: FIRST_DIRECTION[column] ?? 'asc' };
  }

  return { [column]: descriptor.direction === 'descending' ? 'desc' : 'asc' };
}
